import { LinkFieldValue, Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';

export type C12LinkedListEnhancedItemProps = RenderingProps<
  C12LinkedListEnhancedItemFields,
  C12LinkedListEnhancedItemParams
>;

export type C12LinkedListEnhancedItemFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  Links?: C12LinkedListEnhancedItemLinksField;
};

export type C12LinkedListEnhancedItemLinksField = {
  value?: Array<LinkFieldValue>;
};

export type C12LinkedListEnhancedItemParams = {
  HeadlineTag?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
